import { Component, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy, DoCheck, ViewEncapsulation } from '@angular/core';
import { ProjectmanagementService } from '../../service/projectmanagement.service';


@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-ctl-prj-subject-form',
  templateUrl: './ctl.project.subject.component.html',
  styleUrls: ['./ctl.project.subject.component.css'],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [ProjectmanagementService]
})


export class ProjectSubjectComponent implements OnInit, DoCheck {

  @Input() projectData: any;
  @Input() mySubjectList = [];
  @Input() mySelectedSubjectsList = [];
  @Input() type: string;
  @Output() evRemoveSubject: EventEmitter<any> = new EventEmitter();
  @Output() evAddSubject: EventEmitter<any> = new EventEmitter();

  subjectList = [];
  selectedSubjectsList = [];
  subjectState = '';
  subjectListId = [];

  loaded = false;
  subject = '';
  textDir:any;
  constructor() {
    this.textDir = sessionStorage.getItem('textDir');
  }

  ngOnInit() {
    if (this.mySubjectList){
      this.subjectList = this.mySubjectList;
      this.loaded = true;
    }
    if (this.mySelectedSubjectsList){
      this.selectedSubjectsList = this.mySelectedSubjectsList;
      this.loaded = true;
    }
  }


  ngDoCheck() {
    if (this.subjectList !== this.mySubjectList) {
        this.subjectList = this.mySubjectList;
        this.loaded = true;
    }
    if (this.selectedSubjectsList !== this.mySelectedSubjectsList) {
        this.selectedSubjectsList = this.mySelectedSubjectsList;
        this.loaded = true;
    }
  }

  removeSubject(value) {
    this.evRemoveSubject.emit(value);
  }

  onAddSubject(data) {
    this.evAddSubject.emit(data);
    this.subject = '';
  }

  myListFormatter(item: any): string {
    if (item) {
      return `${item['name']}`;
    }
  }

  myValueFormatter(item: any): string {
    if (item) {
      return `${item['name']}`;
    }
  }

}
